import { heroStats } from "@/mocks/home";

const heroImg =
  "https://readdy.ai/api/search-image?query=editorial%20flat%20lay%20of%20newspaper%20clippings%20sticky%20notes%20and%20an%20espresso%20cup%20on%20a%20warm%20cream%20desk%20with%20crimson%20red%20accent%20highlights%20soft%20daylight%20calm%20minimal%20composition%20high%20detail&width=1200&height=900&seq=51eat-hero-2026&orientation=landscape";

export default function Hero() {
  return (
    <section className="shell border-b border-background-200">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-10 px-4 py-10 md:py-14 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14">
        {/* 左：文字主导（双栏对开） */}
        <div className="order-2 lg:order-1">
          <p className="inline-flex items-center gap-2 rounded-full border border-accent-300 bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-900">
            <i className="ri-radar-line" />
            资讯聚合 · 持续更新 · 实时跟进
          </p>
          <h1 className="mt-6 font-heading text-3xl font-black leading-[1.15] tracking-tight text-foreground-950 md:text-[2.75rem]">
            热点不剧终，
            <span className="text-primary-600">51吃料</span>
            <br className="hidden md:block" />
            替你把后续跟到底
          </h1>
          <p className="mt-5 max-w-xl text-[15px] leading-7 text-foreground-600">
            一条线索从起点到结局，我们把每个转折都留痕：哪个口径在变、谁又回应了、下一步怎么走。
            后续发展跟踪报道不是一句口号——想第一时间知道进展，就盯住这条持续更新的档案。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#follow"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-500"
            >
              查看正在跟进的线
              <i className="ri-arrow-right-line" />
            </a>
            <a
              href="#briefing"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              先看近 24h 速览
            </a>
          </div>

          <dl className="mt-9 grid grid-cols-3 gap-4 border-t border-background-200 pt-6">
            {heroStats.map((s, i) => (
              <div key={i}>
                <dt className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
                  {s.value}
                  <span className="sr-only">{s.label}</span>
                </dt>
                <dd className="mt-1 text-xs leading-5 text-foreground-500">{s.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        {/* 右：配图（克制） */}
        <div className="order-1 lg:order-2">
          <div className="relative overflow-hidden rounded-xl border border-background-200">
            <div className="relative h-[300px] w-full overflow-hidden md:h-[400px]">
              <img src={heroImg} alt="51吃料 持续更新实时跟进的最新进展留痕桌面" className="h-full w-full object-cover object-center" />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/45 via-foreground-950/5 to-transparent" />
            </div>
            <div className="absolute inset-x-4 bottom-4 flex items-center justify-between gap-3 rounded-lg bg-background-50/90 px-3 py-2 backdrop-blur-sm">
              <div className="flex items-center gap-2">
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-accent-500 text-sm text-foreground-950">
                  <i className="ri-flashlight-fill" />
                </span>
                <p className="text-xs text-foreground-700">
                  今日焦点 <span className="mx-1 text-foreground-300">·</span>
                  <span className="font-semibold text-foreground-950">「蓝海」咖啡翻红线</span>
                </p>
              </div>
              <span className="whitespace-nowrap rounded-full bg-primary-100 px-2.5 py-1 text-[11px] font-semibold text-primary-700">
                已跟进第 6 轮
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}